<template>
    <div v-if="status === true">

        <van-row>
            <van-col span="21">

                <div style="">
                    <van-tabs v-model="active_model" @click="onSelect" v-if="status===true"
                              swipeable
                              :border="false"
                              :color="'#EE0A24'"
                              :title-active-color="'#EE0A24'"
                              :title-inactive-color="''"
                              :background="'#FFFFFF'"
                    >

                        <van-tab v-for="(item,index) in category_list" :key="index"
                                 :title="item.cat_name"
                                 :name="item.cat_id"
                        >
                            <div slot="title" style="font-size: 16px">{{item.cat_name}}</div>
                        </van-tab>
                    </van-tabs>
<!--                    <div v-if="showCategoryTabs_home_float_div"-->
<!--                         style="position: absolute; top: 50px; height: 46px; line-height: 46px; padding: 1px 26px; font-size: 14px;-->
<!--                            background-color: #ffffff; color: #818283; box-shadow:4px 0 5px -5px #999;"-->
<!--                         @click="clickHomeFloatDiv">-->
<!--                        爆款-->
<!--                    </div>-->
                </div>
            </van-col>
            <van-col span="3" style="">
                <div style="padding-left: 3px; height: 100%; width: 100%; ">
                    <div style="text-align: center; margin-top: 1px; margin-right: 5px; box-shadow: -3px 0 5px -5px #555;">
                        <van-icon name="bars" size="30" style="padding-top: 6px" :color="'#EE0A24'" @click="showTopPop"/>
                    </div>
                </div>

            </van-col>
        </van-row>

<!--        <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>-->

        <van-popup
                v-model="showPop"
                position="top"
        >
            <div>
                <div style="text-align: center; padding: 10px 0px">
                    <span style="font-size: 16px">全部分类</span>
                    <van-icon name="close" size="22" color="#EE0A24" @click="clickCloseIcon"
                              style="position: absolute; right: 15px; margin-top: 2px"
                    />
                </div>
                <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>
                <div style="text-align: center">
                    <van-grid :column-num="columnNum" :border="false" style="padding: 10px 10px">
                        <van-grid-item
                                v-for="(tag, index) in category_list"
                                :key="index"
                        >
                            <van-tag :plain="!isTagClicked(index)" :type="isTagClicked(index)? 'danger' : 'primary'" size="medium" @click="clickTag(index)">
                                <div slot="default" style="width: 60px">
                                    {{tag.cat_name}}
                                </div>
                            </van-tag>
                        </van-grid-item>
                    </van-grid>
                </div>

            </div>
        </van-popup>
    </div>
</template>

<script>
    export default {
        name: "TbCategoryTabs",
        components: {},
        props:{
            // active:{type: String, default: "0"}
            showTabsHome:{type: Boolean, defalut: true}
        },

        // inject: ['JdSelectListSheet_parent'],

        data() {
            return {
                status: false,
                category_list: [
                    // {
                    //     grade: "-2",
                    //     id: "-2",
                    //     img: "http://api.wapg.cn/jd_union/images/group/01.png",
                    //     name: "推荐",
                    //     parentId: "-2",
                    // },

                    {
                        level: 1,
                        cat_name: "全部",
                        cat_id: '-1',
                        parent_cat_id: 0,
                    }
                ],
                active_model: this.active,

                showPop: false,

                // // 屏幕宽
                screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                //
                // tag_width: ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) / 5),

                columnNum: 4,

                tag_type: "primary",

                clicked_tag_index: 0,

                clicked_tag_index_temp: -1,
                //是否显示类别tab嘴边悬浮的"推荐div"（仅在类别tab的list的index>=3时才显示）
                showCategoryTabs_home_float_div: false,
            }
        },
        watch:{
            showTabsHome(newValue){
                this.$log("showTabsHome = " +newValue);
                if(!newValue){
                    this.category_list.splice(0, 1);
                    this.showCategoryTabs_home_float_div = false;
                }
            }
        },
        created() {
            this.getCategoryList();
            if(this.screenWidth >= 400){
                this.columnNum = 4;
            }else{
                this.columnNum = 3;
            }
        },
        methods: {

            clickHomeFloatDiv(){
                this.showCategoryTabs_home_float_div = false;
                this.active_model = "-2";
                this.onSelect("-2");
            },

            /**
             * 顶部弹出的类别选择弹窗中，tag被点击选中
             * @param index
             * @return {boolean}
             */
            isTagClicked(index){
                // this.$log("isTagClicked ----  index = " + index)
                if((this.clicked_tag_index !== -1 && this.clicked_tag_index === index)){

                    return true;
                }else{
                    return false;
                }
            },

            clickTag(index){
                // this.$log("clickTag ----  index = " + index)
                this.clicked_tag_index = index;
                if(this.category_list){
                    let tag_item = this.category_list[index];
                    this.onSelect(tag_item.cat_id);
                    this.active_model = tag_item.cat_id;
                    // this.tag_type = "danger";
                }

                this.clickCloseIcon();
            },

            clickCloseIcon(){
                this.showPop = false;
            },

            showTopPop(){
                this.showPop = true;
            },

            getCategoryList() {
                let temp_list = this.getDiyCatsArray();

                this.category_list.push.apply(this.category_list, temp_list);

                this.status = true;

                // let params = {
                //     catid: '0'
                // };
                // this.$getGoodsCats_pdd(params, response=>{
                //     if(response && response.code === 200){
                //         if(response.data && response.data.goods_cats_get_response
                //             && response.data.goods_cats_get_response.goods_cats_list){
                //
                //             let cats_list = response.data.goods_cats_get_response.goods_cats_list;
                //             this.$log(cats_list)
                //             let temp_list = this.getDiyCatsArray(cats_list);
                //
                //             this.category_list.push.apply(this.category_list, temp_list);
                //
                //             this.status = true;
                //         }
                //     }
                // })
            },

            getDiyCatsArray(){
                let temp_list = [];
                temp_list.push(this.getCatsItem('16', '女装'));//女装/女士精品
                temp_list.push(this.getCatsItem('30', '男装'));//男装
                temp_list.push(this.getCatsItem('1512', '手机'));//手机
                temp_list.push(this.getCatsItem('50018004', '办公用品'));//文具电教/文化用品/商务用品
                temp_list.push(this.getCatsItem('50008090', '数码配件'));//3C数码配件
                temp_list.push(this.getCatsItem('1101,124044001,50018222', '电脑'));//笔记本电脑,品牌台机/品牌一体机/服务器,DIY电脑
                temp_list.push(this.getCatsItem('50002766', '零食/特产'));//零食/坚果/特产
                temp_list.push(this.getCatsItem('50026316', '咖啡/冲饮'));//咖啡/麦片/冲饮
                temp_list.push(this.getCatsItem('50008141', '酒类'));//咖啡/麦片/冲饮
                temp_list.push(this.getCatsItem('26', '汽车用品'));//汽车用品/电子/清洗/改装
                temp_list.push(this.getCatsItem('50011740', '流行男鞋'));//流行男鞋
                temp_list.push(this.getCatsItem('50006843', '女鞋'));//女鞋
                temp_list.push(this.getCatsItem('50006842', '箱包皮具'));//箱包皮具/热销女包/男包
                temp_list.push(this.getCatsItem('50010404', '服饰配件'));//服饰配件/皮带/帽子/围巾
                temp_list.push(this.getCatsItem('50010728', '瑜伽/健身'));//运动/瑜伽/健身/球迷用品
                temp_list.push(this.getCatsItem('50011699', '运动/休闲'));//运动服/休闲服装
                temp_list.push(this.getCatsItem('50012029', '运动鞋'));//运动鞋new
                temp_list.push(this.getCatsItem('21', '居家日用'));//居家日用
                temp_list.push(this.getCatsItem('50013864', '时尚饰品'));//饰品/流行首饰/时尚饰品新
                temp_list.push(this.getCatsItem('1801', '美容护肤'));//美容护肤/美体/精油


                return temp_list;
            },

            getCatsItem(index, name){
                return {
                    cat_name: name,
                    cat_id: index,
                }
            },

            getCatsItemReName(list, index, newName){
                if(list && list.length && index < list.length){
                    let item = list[index];
                    item.cat_name = newName;
                    return item;
                }
            },

            onSelect(tabID) {
                let selectIndex = -1;
                let selectData = null;
                // for (let i in this.category_list) {
                //     let item = this.category_list[i];
                //     if (item.cat_id === tabID) {
                //         selectIndex = i;
                //         selectData = item;
                //         break;
                //     }
                // }
                this.$log(tabID)

                for(let i = 0; i < this.category_list.length; i++){
                    let item = this.category_list[i];

                    if (item.cat_id === tabID) {
                        selectIndex = i;
                        selectData = item;
                        break;
                    }
                }
                if(selectIndex === -1){
                    this.clicked_tag_index = 0;
                }
                this.$log("this.clicked_tag_index_temp = " +this.clicked_tag_index_temp)
                this.$log("selectIndex = " +selectIndex)
                if(selectData){
                    //此处判断是将clicked_tag_index作为一个临时缓存，如果不相同，则触发回调，相同，则不触发，以避免点击相同标签时，每次都加载
                    if(this.clicked_tag_index_temp !== selectIndex){
                        this.$log("2222")
                        this.$emit('onSelect', selectData);
                        if(selectIndex !== -1){
                            //将顶部弹窗的tag设置为相对应的选项
                            this.clicked_tag_index = selectIndex;
                            this.clicked_tag_index_temp = selectIndex;
                        }
                    }
                }

                // if(selectIndex >= 3 && this.showTabsHome && !this.JdSelectListSheet_parent.showHome){
                //     this.showCategoryTabs_home_float_div = true;
                // }else{
                //     this.showCategoryTabs_home_float_div = false;
                // }

            }
        },
        // watch:{
        //     active(newValue){
        //         if(newValue === "0"){
        //             this.active_model = newValue;
        //         }
        //     }
        // }
    }
</script>

<style scoped>

    /deep/ .van-grid-item .van-grid-item__content  {
        /*background-color: rgba(255, 255, 255, 0);*/
        padding: 15px 0px;
    }

</style>